import { ArrowDown } from '@/assets/svg';
import { ButtonEnhance } from '@/module/common/componentUI/commonStyleComponents';
import CustomDate from '@/new-components/CustomDate';
import { sortAlphabetically } from '@/utils/sort';
import { CloseCircleFilled } from '@ant-design/icons';
import {
  Grid,
  Button,
  withStyles,
  TextField,
  makeStyles,
  Paper,
} from '@material-ui/core';
import { Autorenew } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import styled from 'styled-components';

const CustomButton = withStyles({
  root: {
    margin: 5,
    paddingLeft: 40,
    paddingRight: 40,

    height: 40,
    minWidth: 160,

    textTransform: 'unset',
    fontWeight: 600,
    borderRadius: 50,
  },
})(Button);

const CustomAutocomplete = withStyles({
  root: {
    '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]':
      {
        paddingRight: 6,
        height: 36,

        '& .MuiAutocomplete-input:first-child': {
          display: (prop) => (prop.isSelected ? 'none' : ''),
        },
      },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input':
      {
        paddingRight: (prop) => (prop.isSelected ? 0 : 42),
      },
  },
})(Autocomplete);

const CustomTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
    },
    '& input': {
      padding: 8,
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  selectWrapper: {
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },

    '& .MuiAutocomplete-option': {
      padding: 8,
      borderRadius: 8,
      margin: '2px 8px',
      '&:first-child': {
        marginTop: 8,
      },
      '&:last-child': {
        marginBottom: 8,
      },
      '&.MuiAutocomplete-option[aria-selected="true"]': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
}));

const GroupSearch = ({
  filterOption,
  setFilterOption,
  date,
  setDate,
  onResetFilterOps,
  listLocations = [],
  setListProjects,
  setLocationFilter,
  defaultDate = '',
  listProjects,
  projectFilter,
  setProjectFilter,
  locationFilter,
}) => {
  const classes = useStyles();
  const onChangeDate = (value) => {
    setFilterOption({ ...filterOption, date: value });
    setDate(value || defaultDate);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginBottom: 16,
      }}
    >
      <Grid container spacing={2} alignItems="flex-end">
        <Grid item md={3} sm={6} xs={12}>
          <CustomDate
            selectedDate={date}
            placeholder="Select date"
            clearable={false}
            onChange={onChangeDate}
          />
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <CustomAutocomplete
            value={listLocations.find((it) => it?.id === locationFilter) || ''}
            autoComplete
            options={sortAlphabetically(listLocations, 'name')}
            getOptionLabel={(option) => option.name || ''}
            onChange={(event, value) => {
              value && setLocationFilter(value.id);
            }}
            popupIcon={<ArrowDown />}
            closeIcon={
              <CloseCircleFilled
                style={{ margin: 0, padding: 0 }}
                className="ant-input-clear-icon"
                onClick={(e) => {
                  setProjectFilter('');
                  setLocationFilter('');
                  setListProjects([]);
                }}
              />
            }
            renderInput={(params) => (
              <CustomTextField
                fullWidth
                variant="outlined"
                placeholder="Select location"
                {...params}
              />
            )}
            PaperComponent={({ children, ...other }) => (
              <Paper {...other} className={classes.selectWrapper}>
                {children}
              </Paper>
            )}
          />
        </Grid>
        <Grid item md={3} sm={6} xs={12}>
          <p
            style={{ color: '#8f9ba9', padding: '0px 11px' }}
          >{`(Optional)`}</p>
          <CustomAutocomplete
            value={listProjects.find((it) => it?.id === projectFilter) || ''}
            autoComplete
            options={sortAlphabetically(listProjects, 'name')}
            getOptionLabel={(option) => option.name}
            onChange={(event, value) => {
              value && setProjectFilter(value?.id);
            }}
            popupIcon={<ArrowDown />}
            closeIcon={
              <CloseCircleFilled
                style={{ margin: 0, padding: 0 }}
                className="ant-input-clear-icon"
                onClick={(e) => {
                  setProjectFilter('');
                }}
              />
            }
            renderInput={(params) => (
              <CustomTextField
                fullWidth
                variant="outlined"
                placeholder="Select project"
                {...params}
              />
            )}
          />
        </Grid>

        <Grid container justify="flex-end" style={{ marginRight: 16 }}>
          <CustomButton
            onClick={() => {
              onResetFilterOps();
            }}
            variant="contained"
            color="primary"
            endIcon={<Autorenew />}
            style={{ borderRadius: 50, margin: 5 }}
          >
            Reset Filter
          </CustomButton>
        </Grid>
      </Grid>
    </div>
  );
};

export const StyledButtonEnhance = styled(ButtonEnhance)`
  max-width: 160px;
  display: flex;
  align-self: flex-end;
  justify-content: center;
  margin: 12px;
  .add-group {
    display: flex;
    width: fit-content;
    align-items: center;
    margin-top: -2px;
    span {
      margin-right: 8px;
      color: #cacfd3;
    }
  }
`;

export default GroupSearch;
